<template>
    <div class="c-radio-group__wrap">
        <template v-if="isFocus || isEmpty">
            <span class="c-radio-group__title">{{label}}</span>
            <ul class="c-radio-group__list">
                <li class="c-radio-group__item" :class="isItemSelect(item.value)" v-for="(item, key) in valueList">
                    <label class="c-radio-group__item-wrap" v-on:click="selectItem(item.value, key)">
                        <span class="c-radio-group__item-name">{{item.label}}</span>
                        <input type="radio" :name="fieldName" class="c-radio-group__input">
                    </label>
                </li>
            </ul>
        </template>
        <template v-if="isComplete">
            <div class="c-radio-group__complete-wrap">
                <span class="c-radio-group__complete-title">{{label}}</span>
                <span class="c-radio-group__complete-value" v-on:click="edit">{{localItem.label}}</span>
            </div>
        </template>
    </div>
</template>

<script>
    import {STATUSES} from "../statuses";
    import each from 'lodash/each'
    export default {
        name: 'cRadioGroup',
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            checked: {},
            valueList: {
                type: Array,
                required: true
            },
            fieldName: {
                required: true
            },
            label: {
                default: 'Заголовок',
            },

        },
        data() {

            return {
                localValue: this.checked,
                localItem: {},
                status: STATUSES.EMPTY
            }
        },
        watch: {
            valueList: function(newVal, oldVal){
                let _this = this;
                let haveInList = false;
                  if( this.checked !== '' && this.checked){
                      each(newVal, function (item, key) {
                          if( item.value == _this.checked){
                              _this.localItem  = item;
                              haveInList = true;
                              _this.status = STATUSES.COMPLETE;
                          }
                      });
                  }
            },
            checked: function (newVal, oldVal) {
                let _this = this;
                if (newVal !== oldVal) {
                    this.localValue = newVal;
                    each(this.valueList, function (item, key) {
                        if( item.value === newVal){
                            _this.localItem  = item;
                            _this.status = STATUSES.COMPLETE;
                        }
                    });
                }
                if( newVal === ''){
                    this.edit();
                }
            },
            localValue: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit('change', newVal);
                }
            }
        },
        methods: {
            selectItem: function (value, key) {
                this.localValue = value;
                this.localItem = this.valueList[key];
                this.status = STATUSES.COMPLETE;
                this.$emit('change', this.localValue);
            },
            edit: function () {
                this.status = STATUSES.FOCUS;
            },
            isItemSelect: function (value) {
                return {'c-radio-group__item--selected': this.localValue === value};
            },
        },
        computed: {
            isEmpty: function () {
                return this.localValue === '';
            },
            isFocus: function () {
                return this.status === STATUSES.FOCUS;
            },
            isComplete: function () {
                return this.status === STATUSES.COMPLETE;
            },
        },
        mounted(){
            let _this = this;
            if( this.checked !== '' ){
                each(this.valueList, function (item, key) {
                   if( item.value === _this.checked){
                       _this.localItem  = item;
                       _this.status = STATUSES.COMPLETE;
                   }
                });
            }
        }

    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    .c-radio-group {
        &__wrap {
            margin:  0 10px 10px;
            padding-top: 5px;
            text-align: left;
        }
        &__list {
            list-style-type: none;
        }

        &__item {
            margin: 3px 0;
            text-align: left;
        }
        &__item--selected {
            .c-radio-group__item-wrap {
                background-color: rgba(255, 183, 0, 0.3);
            }
        }
        &__item-wrap {
            &:hover{
                cursor: pointer;
            }
            max-width: 100%;
            width: 100%;
            display: block;
            padding: 15px 10px;
            background-color: rgba(255, 183, 0, 0.12);
        }
        &__item-name {
            font-size: 16px;
            font-family: $RobotoRegular;
            color: #333333;
            line-height: 1;
        }
        &__title {
            text-align: left;
            color: $purple-site;
            font-family: $RobotoRegular;
            font-size: 14px;
        }
        &__input {
            display: none;
        }

        &__complete-wrap {
            border-bottom: 1px solid #979797;
            display: flex;
            padding: 0 10px 5px;
            justify-content: space-between;
        }
        &__complete-title {
            font-size: 14px;
            color: #9b9b9b;
            line-height: 1.2;
        }
        &__complete-value {
            color: $yellow-1;
            font-size: 14px;
            text-align: right;
            text-decoration: underline;
        }
    }
</style>